<script lang="ts" setup>
import { set, watchDebounced } from '@vueuse/core';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { ref } from 'vue';
import { useStepperStore } from '../../stores/stepper.store.js';
import DateCard from './components/date-card.vue';
import { useConfiguration } from './composables/use.configuration.js';
import { useDates } from './composables/use.dates.js';

const { config } = useConfiguration();
const { dates } = useDates(config);
const selectedDate = ref<string>();

const modules = [Navigation];

watchDebounced(
  config,
  () => {
    const firstAvailableDate = dates.value.at(0);

    if (firstAvailableDate !== undefined) {
      selectDate(firstAvailableDate.date, firstAvailableDate.value);
    }
  },
  { debounce: 1000 },
);

function selectDate(date: Date, value: string) {
  set(selectedDate, value);
  useStepperStore().getState().deliveryDate.update(date);
}
</script>

<template>
  <Swiper
    :modules="modules"
    :breakpoints="{
      0: {
        slidesPerView: 1.5,
      },
      640: {
        slidesPerView: 2.5,
      },
      768: {
        slidesPerView: 3.5,
      },
      1024: {
        slidesPerView: 4,
      },
    }"
    :slides-per-view="4"
    :space-between="12"
    :navigation="{
      prevEl: '.date-radio-slider-button--prev',
      nextEl: '.date-radio-slider-button--next',
    }"
  >
    <SwiperSlide v-for="date in dates" :key="date.date.toISOString()">
      <DateCard
        class="date-radio-container"
        :content="date.htmlContent"
        :date="date.date"
        :value="date.value"
        :model-value="selectedDate === date.value"
        @selected="() => selectDate(date.date, date.value)"
      />
    </SwiperSlide>
  </Swiper>
</template>
